import {
  __esm,
  __spreadValues
} from "./chunk-ZU6LNBSF.mjs";

// src/icons/QrCodeFilled.tsx
import React from "react";
var SvgQrCodeFilled, QrCodeFilled_default;
var init_QrCodeFilled = __esm({
  "src/icons/QrCodeFilled.tsx"() {
    SvgQrCodeFilled = (props) => /* @__PURE__ */ React.createElement(
      "svg",
      __spreadValues({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
      }, props),
      /* @__PURE__ */ React.createElement(
        "path",
        {
          fill: "currentColor",
          d: "M16 17v-1h-3v-3h3v2h2v2h-1v2h-2v2h-2v-3h2v-1h1Zm5 4h-4v-2h2v-2h2v4ZM3 3h8v8H3V3Zm10 0h8v8h-8V3ZM3 13h8v8H3v-8Zm15 0h3v2h-3v-2ZM6 6v2h2V6H6Zm0 10v2h2v-2H6ZM16 6v2h2V6h-2Z"
        }
      )
    );
    QrCodeFilled_default = SvgQrCodeFilled;
  }
});

export {
  QrCodeFilled_default,
  init_QrCodeFilled
};
